import React from "react";
import Draggable from "react-draggable";
import firebase from "../../../lib/fire";
import { Link } from "react-router-dom";
import { SuccessPopUp, Modal, VideoSlider } from "../../componentes";
import {
  Container,
  Court,
  Sidebar,
  RedDot,
  AnimatorBar,
  Square,
  Navbar,
  SectorNav,
  BallDot,
  BlueDot,
  AnimatorBarContainer,
} from "./styled";
import secureLocalStorage from "react-secure-storage";

const SquareShape = () => <div className="resize both">Resize me!</div>;

class EdicionContainer extends React.Component {
  constructor(props) {
    super(props);
    this.timeoutRef = React.createRef(null);
    this.isLongPress = React.createRef();
    this.pressHoldEvent = new CustomEvent("pressHold");
    this.state = {
      movimientos0: [],
      movimientos1: [],
      movimientos2: [],
      movimientos3: [],
      movimientos4: [],
      movimientosB0: [],
      movimientosB1: [],
      movimientosB2: [],
      movimientosB3: [],
      movimientosB4: [],
      movimientosBall: [],
      movimientos0Mobile: [],
      movimientos1Mobile: [],
      movimientos2Mobile: [],
      movimientos3Mobile: [],
      movimientos4Mobile: [],
      movimientosB0Mobile: [],
      movimientosB1Mobile: [],
      movimientosB2Mobile: [],
      movimientosB3Mobile: [],
      movimientosB4Mobile: [],
      movimientosBallMobile: [],
      ownPlayers: [],
      rivalPlayers: [],
      shapes: [],
      Ball: [],
      positions: 0,
      animationRunning: false,
      firstClickPlay: true,
      animationLoopState: false,
      loopIterations: 1,
      animatiomultipliedspeed: false,
      width: window.innerWidth,
      deleteExercisePopup: false,
      activeEditPosition: null,
      posToDelete: "position-0",
      isEditModeOn: false,
      isDragin: false,
      isModalOpen: false,
      isVideoModalOpen: false,
      isPlayerSelected: false,
      PopUpposx: 0,
      PopUpposy: 0,
      target: null,
      pos: null,
      maxPosition: 0,
      touchTimer: 0,
      counter: 0,
      isLongPress: false,
    };
    this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
    window.addEventListener("load", function () {
      setTimeout(function () {
        window.scrollTo(0, 1);
      }, 0);
    });

    if (this.props.isEdit) {
      console.log("-----EDIT MODE-----");
      if (this.state.width >= 867) {
        if (this.props.jugada.animations?.desktop?.own !== undefined) {
          this.setState({
            ownPlayers: Object.values(this.props.jugada.animations.desktop.own),
          });
        }
        if (this.props.jugada.animations?.desktop.rivals !== undefined) {
          this.setState({
            rivalPlayers: Object.values(
              this.props.jugada.animations.desktop.rivals
            ),
          });
        }
        if (this.props.jugada.animations?.desktop?.ball !== undefined) {
          this.setState({
            Ball: Object.values(this.props.jugada.animations.desktop.ball),
          });
        }
        this.setState({
          positions: this.props.jugada.animations
            ? Object.values(this.props.jugada.animations?.desktop)[0][0].length
            : "0",
          isEditModeOn: true,
        });
      } else {
        if (this.props.jugada.animations?.mobile.own !== undefined) {
          this.setState({
            ownPlayers: Object.values(this.props.jugada.animations.mobile.own),
          });
        }
        if (this.props.jugada.animations?.mobile.rivals !== undefined) {
          this.setState({
            rivalPlayers: Object.values(
              this.props.jugada.animations?.mobile.rivals
            ),
          });
        }
        if (this.props.jugada.animations?.mobile.ball !== undefined) {
          this.setState({
            Ball: Object.values(this.props.jugada.animations.mobile.ball),
          });
        }
        if (this.props.jugada.animations) {
          this.setState({
            positions: Object.values(this.props.jugada.animations?.mobile)[0][0]
              .length,
            isEditModeOn: true,
          });
        }
      }
      this.props.jugada.animations?.desktop.own?.forEach((movs, i) => {
        switch (i) {
          case 0:
            this.setState({ movimientos0: movs });
            break;
          case 1:
            this.setState({ movimientos1: movs });

            break;
          case 2:
            this.setState({ movimientos2: movs });

            break;
          case 3:
            this.setState({ movimientos3: movs });

            break;
          case 4:
            this.setState({ movimientos4: movs });

            break;
          default:
            break;
        }
      });
      this.props.jugada.animations?.mobile.own?.forEach((movs, i) => {
        switch (i) {
          case 0:
            this.setState({ movimientos0Mobile: movs });
            break;
          case 1:
            this.setState({ movimientos1Mobile: movs });
            break;
          case 2:
            this.setState({ movimientos2Mobile: movs });
            break;
          case 3:
            this.setState({ movimientos3Mobile: movs });
            break;
          case 4:
            this.setState({ movimientos4Mobile: movs });
            break;
          default:
            break;
        }
      });
      this.props.jugada.animations?.desktop.rivals?.forEach((movs, i) => {
        switch (i) {
          case 0:
            this.setState({ movimientosB0: movs });
            break;
          case 1:
            this.setState({ movimientosB1: movs });

            break;
          case 2:
            this.setState({ movimientosB2: movs });

            break;
          case 3:
            this.setState({ movimientosB3: movs });

            break;
          case 4:
            this.setState({ movimientosB4: movs });

            break;
          default:
            break;
        }
      });
      this.props.jugada.animations?.mobile.rivals?.forEach((movs, i) => {
        switch (i) {
          case 0:
            this.setState({ movimientosB0Mobile: movs });
            break;
          case 1:
            this.setState({ movimientosB1Mobile: movs });

            break;
          case 2:
            this.setState({ movimientosB2Mobile: movs });

            break;
          case 3:
            this.setState({ movimientosB3Mobile: movs });

            break;
          case 4:
            this.setState({ movimientosB4Mobile: movs });

            break;
          default:
            break;
        }
      });
      if (
        this.props.jugada.animations?.desktop.ball !== undefined &&
        this.props.jugada.animations?.desktop.ball[0] !== undefined &&
        this.props.jugada.animations?.desktop.ball[0].length > 0
      ) {
        this.setState({
          movimientosBall: this.props.jugada.animations.desktop.ball[0],
          movimientosBallMobile: this.props.jugada.animations.mobile.ball[0],
        });
      }
      this.renderPositions(
        this.props.isEdit,
        this.props.jugada.animations
          ? Object.values(this.props.jugada.animations?.desktop)[0][0].length
          : 0
      );
      let poss = 0;
      if (
        this.props.jugada.animations?.desktop.own &&
        this.props.jugada.animations?.desktop.own[0].length > poss
      ) {
        poss = this.props.jugada.animations?.desktop.own[0].length;
      } else if (
        this.props.jugada.animations?.desktop.rivals &&
        this.props.jugada.animations?.desktop.rivals[0].length > poss
      ) {
        poss = this.props.jugada.animations?.desktop.rivals[0].length;
      } else if (this.props.jugada.animations?.desktop.ball[0].length > poss) {
        poss = this.props.jugada.animations?.desktop.ball[0].length;
      }
      this.setState({ maxPosition: poss });
      if (this.props.jugada.animations) this.setEditPosition("position-0");
    }
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions() {
    this.setState({ width: window.innerWidth });
  }

  renderPlayer() {
    if (this.state.ownPlayers.length < 5) {
      let newComponents = [...this.state.ownPlayers];
      let arr = [];
      if (this.state.maxPosition === 0) {
        arr.push({ left: "0%", top: "0%" });
      } else {
        for (var i = 0; i < this.state.maxPosition; i++) {
          arr.push({ left: "0%", top: "0%" });
        }
      }
      switch (this.state.ownPlayers.length) {
        case 0:
          this.setState({
            movimientos0: arr,
            movimientos0Mobile: arr,
          });
          break;
        case 1:
          this.setState({
            movimientos1: arr,
            movimientos1Mobile: arr,
          });
          break;
        case 2:
          this.setState({
            movimientos2: arr,
            movimientos2Mobile: arr,
          });
          break;
        case 3:
          this.setState({
            movimientos3: arr,
            movimientos3Mobile: arr,
          });
          break;
        case 4:
          this.setState({
            movimientos4: arr,
            movimientos4Mobile: arr,
          });
          break;
        default:
          break;
      }
      newComponents.push(arr);
      this.setState({
        ownPlayers: newComponents,
      });
    } else {
      alert("no more players");
    }
  }

  renderRivalPlayer() {
    if (this.state.rivalPlayers.length < 5) {
      let newComponents = [...this.state.rivalPlayers];
      let arr = [];
      if (this.state.maxPosition === 0) {
        arr.push({ left: "0%", top: "0%" });
      } else {
        for (var i = 0; i < this.state.maxPosition; i++) {
          arr.push({ left: "0%", top: "0%" });
        }
      }
      switch (this.state.rivalPlayers.length) {
        case 0:
          this.setState({
            movimientosB0: arr,
            movimientosB0Mobile: arr,
          });
          break;
        case 1:
          this.setState({
            movimientosB1: arr,
            movimientosB1Mobile: arr,
          });
          break;
        case 2:
          this.setState({
            movimientosB2: arr,
            movimientosB2Mobile: arr,
          });
          break;
        case 3:
          this.setState({
            movimientosB3: arr,
            movimientosB3Mobile: arr,
          });
          break;
        case 4:
          this.setState({
            movimientosB4: arr,
            movimientosB4Mobile: arr,
          });
          break;
        default:
          break;
      }
      newComponents.push(arr);
      this.setState({
        rivalPlayers: newComponents,
      });
    } else {
      alert("no more players");
    }
  }
  renderBall() {
    if (this.state.Ball.length < 1) {
      let newComponents = [...this.state.Ball];
      let arr = [];
      if (this.state.maxPosition === 0) {
        arr.push({ left: "0%", top: "0%" });
      } else {
        for (var i = 0; i < this.state.maxPosition; i++) {
          arr.push({ left: "0%", top: "0%" });
        }
      }
      switch (this.state.Ball.length) {
        case 0:
          this.setState({
            movimientosBall: arr,
            movimientosBallMobile: arr,
          });
          break;
        default:
          break;
      }
      newComponents.push(arr);
      this.setState({
        Ball: newComponents,
      });
    } else {
      alert("no more Balls");
    }
  }

  // renderSquare() {
  //   const newShapes = [...this.state.shapes, SquareShape];
  //   this.setState({
  //     shapes: newShapes,
  //   });
  // }

  handleLoop = () => {
    var loopstate = !this.state.animationLoopState;
    this.setState({
      animationLoopState: loopstate,
    });

    if (loopstate) {
      this.setState({
        loopIterations: Infinity,
      });
    } else {
      this.setState({
        loopIterations: 1,
      });
      document.getAnimations().forEach(function (animation) {
        animation.cancel();
      });
      this.setState({
        animationRunning: false,
        firstClickPlay: true,
      });
    }
  };

  //TEST END ANIMAITON
  onFinishAnimation = () => {
    this.setState({
      animationRunning: false,
      firstClickPlay: true,
    });
    var player0 = document.getElementById("0");
    var player1 = document.getElementById("1");
    var player2 = document.getElementById("2");
    var player3 = document.getElementById("3");
    var player4 = document.getElementById("4");
    var rival0 = document.getElementById("b-0");
    var rival1 = document.getElementById("b-1");
    var rival2 = document.getElementById("b-2");
    var rival3 = document.getElementById("b-3");
    var rival4 = document.getElementById("b-4");
    var ball = document.getElementById("Ball");
    if (this.state.width >= 867) {
      this.state.ownPlayers.forEach((player, i) => {
        switch (i) {
          case 0:
            player0.style.left = `${this.state.movimientos0[0].left}`;
            player0.style.top = `${this.state.movimientos0[0].top}`;
            break;
          case 1:
            player1.style.left = `${this.state.movimientos1[0].left}`;
            player1.style.top = `${this.state.movimientos1[0].top}`;
            break;
          case 2:
            player2.style.left = `${this.state.movimientos2[0].left}`;
            player2.style.top = `${this.state.movimientos2[0].top}`;
            break;
          case 3:
            player3.style.left = `${this.state.movimientos3[0].left}`;
            player3.style.top = `${this.state.movimientos3[0].top}`;
            break;
          case 4:
            player4.style.left = `${this.state.movimientos4[0].left}`;
            player4.style.top = `${this.state.movimientos4[0].top}`;
            break;
          default:
            break;
        }
      });
      this.state.rivalPlayers.forEach((player, i) => {
        switch (i) {
          case 0:
            rival0.style.left = `${this.state.movimientosB0[0].left}`;
            rival0.style.top = `${this.state.movimientosB0[0].top}`;
            break;
          case 1:
            rival1.style.left = `${this.state.movimientosB1[0].left}`;
            rival1.style.top = `${this.state.movimientosB1[0].top}`;
            break;
          case 2:
            rival2.style.left = `${this.state.movimientosB2[0].left}`;
            rival2.style.top = `${this.state.movimientosB2[0].top}`;
            break;
          case 3:
            rival3.style.left = `${this.state.movimientosB3[0].left}`;
            rival3.style.top = `${this.state.movimientosB3[0].top}`;
            break;
          case 4:
            rival4.style.left = `${this.state.movimientosB4[0].left}`;
            rival4.style.top = `${this.state.movimientosB4[0].top}`;
            break;
          default:
            break;
        }
      });
      this.state.movimientosBall?.forEach((movimiento, index) => {
        ball.style.left = `${this.state.movimientosBall[0].left}`;
        ball.style.top = `${this.state.movimientosBall[0].top}`;
      });
    } else if (this.state.width <= 867) {
      this.state.ownPlayers.forEach((player, i) => {
        switch (i) {
          case 0:
            player0.style.left = `${this.state.movimientos0Mobile[0].left}`;
            player0.style.top = `${this.state.movimientos0Mobile[0].top}`;
            break;
          case 1:
            player1.style.left = `${this.state.movimientos1Mobile[0].left}`;
            player1.style.top = `${this.state.movimientos1Mobile[0].top}`;
            break;
          case 2:
            player2.style.left = `${this.state.movimientos2Mobile[0].left}`;
            player2.style.top = `${this.state.movimientos2Mobile[0].top}`;
            break;
          case 3:
            player3.style.left = `${this.state.movimientos3Mobile[0].left}`;
            player3.style.top = `${this.state.movimientos3Mobile[0].top}`;
            break;
          case 4:
            player4.style.left = `${this.state.movimientos4Mobile[0].left}`;
            player4.style.top = `${this.state.movimientos4Mobile[0].top}`;
            break;
          default:
            break;
        }
      });
      this.state.rivalPlayers.forEach((player, i) => {
        switch (i) {
          case 0:
            rival0.style.left = `${this.state.movimientosB0Mobile[0].left}`;
            rival0.style.top = `${this.state.movimientosB0Mobile[0].top}`;
            break;
          case 1:
            rival1.style.left = `${this.state.movimientosB1Mobile[0].left}`;
            rival1.style.top = `${this.state.movimientosB1Mobile[0].top}`;
            break;
          case 2:
            rival2.style.left = `${this.state.movimientosB2Mobile[0].left}`;
            rival2.style.top = `${this.state.movimientosB2Mobile[0].top}`;
            break;
          case 3:
            rival3.style.left = `${this.state.movimientosB3Mobile[0].left}`;
            rival3.style.top = `${this.state.movimientosB3Mobile[0].top}`;
            break;
          case 4:
            rival4.style.left = `${this.state.movimientosB4Mobile[0].left}`;
            rival4.style.top = `${this.state.movimientosB4Mobile[0].top}`;
            break;
          default:
            break;
        }
      });
      this.state.movimientosBall.forEach((movimiento, index) => {
        ball.style.left = `${this.state.movimientosBallMobile[0].left}`;
        ball.style.top = `${this.state.movimientosBallMobile[0].top}`;
      });
    }
  };
  //
  //animacion de los jugadores
  play = () => {
    this.setState({
      animationRunning: true,
    });
    if (this.state.firstClickPlay) {
      var player0 = document.getElementById("0");
      var player1 = document.getElementById("1");
      var player2 = document.getElementById("2");
      var player3 = document.getElementById("3");
      var player4 = document.getElementById("4");
      var rival0 = document.getElementById("b-0");
      var rival1 = document.getElementById("b-1");
      var rival2 = document.getElementById("b-2");
      var rival3 = document.getElementById("b-3");
      var rival4 = document.getElementById("b-4");
      var ball = document.getElementById("Ball");
      const animationInfo = {
        duration: !this.state.animatiomultipliedspeed
          ? this.state.positions * 1000
          : (this.state.positions * 1000) / 2,
        iterations: this.state.loopIterations,
      };
      if (this.state.width >= 867) {
        //desktop animations
        console.log("--- DESKTOP PLAY ----");
        this.state.ownPlayers.forEach((player, i) => {
          switch (i) {
            case 0:
              player0.style.removeProperty("transform");
              player0.animate(this.state.movimientos0, animationInfo);
              break;
            case 1:
              player1.style.removeProperty("transform");
              player1.animate(this.state.movimientos1, animationInfo);
              break;
            case 2:
              player2.style.removeProperty("transform");
              player2.animate(this.state.movimientos2, animationInfo);
              break;
            case 3:
              player3.style.removeProperty("transform");
              player3.animate(this.state.movimientos3, animationInfo);
              break;
            case 4:
              player4.style.removeProperty("transform");
              player4.animate(this.state.movimientos4, animationInfo);
              break;
            default:
              break;
          }
        });
        this.state.rivalPlayers.forEach((player, i) => {
          switch (i) {
            case 0:
              rival0.style.removeProperty("transform");
              rival0.animate(this.state.movimientosB0, animationInfo);
              break;
            case 1:
              rival1.style.removeProperty("transform");
              rival1.animate(this.state.movimientosB1, animationInfo);
              break;
            case 2:
              rival2.style.removeProperty("transform");
              rival2.animate(this.state.movimientosB2, animationInfo);
              break;
            case 3:
              rival3.style.removeProperty("transform");
              rival3.animate(this.state.movimientosB3, animationInfo);
              break;
            case 4:
              rival4.style.removeProperty("transform");
              rival4.animate(this.state.movimientosB4, animationInfo);
              break;
            default:
              break;
          }
        });
        this.state.movimientosBall?.forEach((movimiento, index) => {
          ball.style.removeProperty("transform");
          ball.animate(this.state.movimientosBall, animationInfo);
        });
      } else if (this.state.width <= 867) {
        //mobile animations
        console.log("--- MOBILE PLAY ----");
        this.state.ownPlayers.forEach((player, i) => {
          switch (i) {
            case 0:
              player0.style.removeProperty("transform");
              player0.animate(this.state.movimientos0Mobile, animationInfo);
              break;
            case 1:
              player1.style.removeProperty("transform");
              player1.animate(this.state.movimientos1Mobile, animationInfo);
              break;
            case 2:
              player2.style.removeProperty("transform");
              player2.animate(this.state.movimientos2Mobile, animationInfo);
              break;
            case 3:
              player3.style.removeProperty("transform");
              player3.animate(this.state.movimientos3Mobile, animationInfo);
              break;
            case 4:
              player4.style.removeProperty("transform");
              player4.animate(this.state.movimientos4Mobile, animationInfo);
              break;
            default:
              break;
          }
        });
        this.state.rivalPlayers.forEach((player, i) => {
          switch (i) {
            case 0:
              rival0.style.removeProperty("transform");
              rival0.animate(this.state.movimientosB0Mobile, animationInfo);
              break;
            case 1:
              rival1.style.removeProperty("transform");
              rival1.animate(this.state.movimientosB1Mobile, animationInfo);
              break;
            case 2:
              rival2.style.removeProperty("transform");
              rival2.animate(this.state.movimientosB2Mobile, animationInfo);
              break;
            case 3:
              rival3.style.removeProperty("transform");
              rival3.animate(this.state.movimientosB3Mobile, animationInfo);
              break;
            case 4:
              rival4.style.removeProperty("transform");
              rival4.animate(this.state.movimientosB4Mobile, animationInfo);
              break;
            default:
              break;
          }
        });
        this.state.movimientosBall.forEach((movimiento, index) => {
          ball.style.removeProperty("transform");
          ball.animate(this.state.movimientosBallMobile, animationInfo);
        });
      }
      //END ANIMATION
      var players = document.getAnimations();
      players[0].onfinish = this.onFinishAnimation;
      this.setState({
        firstClickPlay: false,
      });
    } else {
      this.setState({
        animationRunning: true,
      });
      var playersAnimation = document.getAnimations();
      playersAnimation.forEach((player, i) => {
        player.play();
      });
    }
  };
  //fin de la animacion de los jugadores

  //PAUSE ANIMATION
  pause = () => {
    this.setState({
      animationRunning: false,
    });
    //Get all the AnimationPlayers
    var players;
    if (typeof document.getAnimations === "function") {
      players = document.getAnimations();
    } else {
      players = document.timeline.getAnimations();
    }
    if (players && players.length) {
      var action;
      if (players[0].playState === "running") {
        action = "pause";
      } else if (players[0].playState === "paused") {
        action = "play";
      } else {
        return;
      }
      players.forEach(function (player, i, ra) {
        player[action](); //player.pause() or player.play()
      });

      //button.value = action === "play" ? "Pause All" : "Play All";
    } else {
      console.log("no more actions");
    }
  };
  //END OF PAUSE ANIMATION

  //RELOAD POSITIONS
  reloadPostions = () => {
    var players = document.getAnimations();
    var action = "finish";
    players.forEach(function (player, i, ra) {
      player[action]();
    });
  };
  // END OF RELOAD POSITIONS

  //SAVE INFO IN DATABASE
  handleSaveClick = () => {
    const popUp = document.getElementById("SuccessPopUp");
    popUp.style.display = "flex";
    setTimeout(() => {
      popUp.style.display = "none";
    }, 2000);
    const own = [
      this.state.movimientos0,
      this.state.movimientos1,
      this.state.movimientos2,
      this.state.movimientos3,
      this.state.movimientos4,
    ];
    const rivals = [
      this.state.movimientosB0,
      this.state.movimientosB1,
      this.state.movimientosB2,
      this.state.movimientosB3,
      this.state.movimientosB4,
    ];
    const ball = [this.state.movimientosBall];
    const ownMobile = [
      this.state.movimientos0Mobile,
      this.state.movimientos1Mobile,
      this.state.movimientos2Mobile,
      this.state.movimientos3Mobile,
      this.state.movimientos4Mobile,
    ];
    const rivalsMobile = [
      this.state.movimientosB0Mobile,
      this.state.movimientosB1Mobile,
      this.state.movimientosB2Mobile,
      this.state.movimientosB3Mobile,
      this.state.movimientosB4Mobile,
    ];
    const ballMobile = [this.state.movimientosBallMobile];
    //---------HACER PUSH DE LA JUGADA A FIREBASE-----------------
    const userId = secureLocalStorage.getItem("userId");
    var playId = this.props.isEdit
      ? this.props.playId
      : window.location.pathname.replace("/app/editions/", "");

    var ref = firebase.database().ref(`/users/0/${userId}/plays/`);
    var blast = ref.child(playId); //recibe el valor de iteracion, que es igual al id del "animal" en la base de datos
    blast
      .update({
        //actualiza la data.
        animations: {
          desktop: {
            own: own,
            rivals: rivals,
            ball: ball,
          },
          mobile: {
            own: ownMobile,
            rivals: rivalsMobile,
            ball: ballMobile,
          },
        },
      })
      .then(function () {
        let userBKP = secureLocalStorage.getItem("user");
        Object.entries(own).filter(
          ([key, value]) => Array.isArray(value) && value.length > 0
        );
        let animation = {
          desktop: {
            own: own.filter((element) => {
              if (Object.keys(element).length !== 0) {
                return true;
              }

              return false;
            }),
            rivals: rivals.filter((element) => {
              if (Object.keys(element).length !== 0) {
                return true;
              }

              return false;
            }),
            ball: ball.filter((element) => {
              if (Object.keys(element).length !== 0) {
                return true;
              }

              return false;
            }),
          },
          mobile: {
            own: ownMobile.filter((element) => {
              if (Object.keys(element).length !== 0) {
                return true;
              }

              return false;
            }),
            rivals: rivalsMobile.filter((element) => {
              if (Object.keys(element).length !== 0) {
                return true;
              }

              return false;
            }),
            ball: ballMobile.filter((element) => {
              if (Object.keys(element).length !== 0) {
                return true;
              }

              return false;
            }),
          },
        };
        userBKP.plays[playId].animations = animation;
        secureLocalStorage.setItem("userLocal", userBKP);
      })
      .catch(function (error) {
        console.log("Data could not be saved." + error);
      });
  };
  //END OF SAVE INFO IN DATABASE

  //STORE POSITIONS ON CLICK
  handlePositionClick = (isClick) => {
    const self = this;
    let stateUpdates = {};
    let stateUpdatesMobile = {};
    let clickProp = isClick;
    //save animations positions in state
    let position = Number(this.state.posToDelete.replace("position-", ""));
    this.state.ownPlayers.forEach((player, i) => {
      var player = document.getElementById(i);
      var style = window.getComputedStyle(player);
      //var matrix = new WebKitCSSMatrix(style.transform);
      const matrix =
        style.transform || style.webkitTransform || style.mozTransform;
      // No transform property. Simply return 0 values.
      if (matrix === "none") {
        return {
          x: 0,
          y: 0,
          z: 0,
        };
      }

      // Can either be 2d or 3d transform
      const matrixType = matrix.includes("3d") ? "3d" : "2d";
      const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(", ");

      // 2d matrices have 6 values
      // Last 2 values are X and Y.
      // 2d matrices does not have Z value.
      if (matrixType === "2d") {
        //--------GUARDAR X E Y EN STATE-----------
        let posx = Math.round(matrixValues[4]);
        let posy = Math.round(matrixValues[5]);
        //save animation positions in % related to court width and height
        let courtWidth = document.getElementById("court").offsetWidth;
        let courtHeight = document.getElementById("court").offsetHeight;

        if (courtWidth >= 867) {
          stateUpdates = {
            left: `${Math.round((posx * 100) / courtWidth)}%`,
            top: `${Math.round((posy * 100) / courtHeight)}%`,
          };
          stateUpdatesMobile = {
            top: `${Math.round((posx * 100) / courtWidth)}%`,
            left: `${100 - Math.round(posy * 100) / courtHeight}%`,
          };
        } else if (courtWidth <= 867) {
          stateUpdates = {
            left: `${Math.round((posy * 100) / courtHeight)}%`,
            top: `${90 - Math.round((posx * 100) / courtWidth)}%`,
          };
          stateUpdatesMobile = {
            top: `${Math.round((posy * 100) / courtHeight)}%`,
            left: `${Math.round((posx * 100) / courtWidth)}%`,
          };
        }
        // eslint-disable-next-line default-case
        switch (i) {
          case 0:
            if (self.state.isEditModeOn === true) {
              let movs = self.state.movimientos0;
              let movsM = self.state.movimientos0Mobile;
              movs[position] = stateUpdates;
              movsM[position] = stateUpdatesMobile;
              let newPos = self.state.ownPlayers;
              newPos[i][position] =
                courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
              self.setState({
                movimientos0: movs,
                movimientos0Mobile: movsM,
                ownPlayers: newPos,
              });
            } else {
              let p = self.state.ownPlayers;
              let movs = [...self.state.movimientos0];
              let movsM = [...self.state.movimientos0Mobile];
              if (clickProp !== "isClick") {
                p[0][self.state.positions] =
                  courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
                movsM[self.state.positions] = stateUpdatesMobile;
                movs[self.state.positions] = stateUpdates;
              }
              self.setState({
                movimientos0: movs,
                movimientos0Mobile: movsM,
                ownPlayers: p,
              });
            }
            break;
          case 1:
            if (self.state.isEditModeOn === true) {
              let movs = self.state.movimientos1;
              let movsM = self.state.movimientos1Mobile;
              movs[position] = stateUpdates;
              movsM[position] = stateUpdatesMobile;
              let newPos = self.state.ownPlayers;
              newPos[i][position] =
                courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
              self.setState({
                movimientos1: movs,
                movimientos1Mobile: movsM,
                ownPlayers: newPos,
              });
            } else {
              let p = self.state.ownPlayers;
              let movs = [...self.state.movimientos1];
              let movsM = [...self.state.movimientos1Mobile];
              if (clickProp !== "isClick") {
                p[i][self.state.positions] =
                  courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
                movsM[self.state.positions] = stateUpdatesMobile;
                movs[self.state.positions] = stateUpdates;
              }
              self.setState({
                movimientos1: movs,
                movimientos1Mobile: movsM,
                ownPlayers: p,
              });
            }
            break;
          case 2:
            if (self.state.isEditModeOn === true) {
              let movs = self.state.movimientos2;
              let movsM = self.state.movimientos2Mobile;
              movs[position] = stateUpdates;
              movsM[position] = stateUpdatesMobile;
              let newPos = self.state.ownPlayers;
              newPos[i][position] =
                courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
              self.setState({
                movimientos2: movs,
                movimientos2Mobile: movsM,
                ownPlayers: newPos,
              });
            } else {
              let p = self.state.ownPlayers;
              let movs = [...self.state.movimientos2];
              let movsM = [...self.state.movimientos2Mobile];
              if (clickProp !== "isClick") {
                p[2][self.state.positions] =
                  courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
                movsM[self.state.positions] = stateUpdatesMobile;
                movs[self.state.positions] = stateUpdates;
              }
              self.setState({
                movimientos2: movs,
                movimientos2Mobile: movsM,
                ownPlayers: p,
              });
            }
            break;
          case 3:
            if (self.state.isEditModeOn === true) {
              let movs = self.state.movimientos3;
              let movsM = self.state.movimientos3Mobile;
              movs[position] = stateUpdates;
              movsM[position] = stateUpdatesMobile;
              let newPos = self.state.ownPlayers;
              newPos[i][position] =
                courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
              self.setState({
                movimientos3: movs,
                movimientos3Mobile: movsM,
                ownPlayers: newPos,
              });
            } else {
              let p = self.state.ownPlayers;
              let movs = [...self.state.movimientos3];
              let movsM = [...self.state.movimientos3Mobile];
              if (clickProp !== "isClick") {
                p[3][self.state.positions] =
                  courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
                movsM[self.state.positions] = stateUpdatesMobile;
                movs[self.state.positions] = stateUpdates;
              }
              self.setState({
                movimientos3: movs,
                movimientos3Mobile: movsM,
                ownPlayers: p,
              });
            }
            break;
          case 4:
            if (self.state.isEditModeOn === true) {
              let movs = self.state.movimientos4;
              let movsM = self.state.movimientos4Mobile;
              movs[position] = stateUpdates;
              movsM[position] = stateUpdatesMobile;
              let newPos = self.state.ownPlayers;
              newPos[i][position] =
                courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
              self.setState({
                movimientos4: movs,
                movimientos4Mobile: movsM,
                ownPlayers: newPos,
              });
            } else {
              let p = self.state.ownPlayers;
              let movs = [...self.state.movimientos4];
              let movsM = [...self.state.movimientos4Mobile];
              if (clickProp !== "isClick") {
                p[4][self.state.positions] =
                  courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
                movsM[self.state.positions] = stateUpdatesMobile;
                movs[self.state.positions] = stateUpdates;
              }
              self.setState({
                movimientos4: movs,
                movimientos4Mobile: movsM,
                ownPlayers: p,
              });
            }
            break;
          default:
            break;
        }
      }
    });

    this.state.rivalPlayers?.forEach((player, i) => {
      var player = document.getElementById(`b-${i}`);
      var style = window.getComputedStyle(player);
      const matrix =
        style.transform || style.webkitTransform || style.mozTransform;
      if (matrix === "none") {
        return {
          x: 0,
          y: 0,
          z: 0,
        };
      }

      // Can either be 2d or 3d transform
      const matrixType = matrix.includes("3d") ? "3d" : "2d";
      const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(", ");

      // 2d matrices have 6 values
      // Last 2 values are X and Y.
      // 2d matrices does not have Z value.
      if (matrixType === "2d") {
        //--------GUARDAR X E Y EN STATE-----------

        let posx = Math.round(matrixValues[4]);
        let posy = Math.round(matrixValues[5]);
        //save animation positions in % related to court width and height
        let courtWidth = document.getElementById("court").offsetWidth;
        let courtHeight = document.getElementById("court").offsetHeight;
        if (courtWidth >= 867) {
          stateUpdates = {
            left: `${Math.round((posx * 100) / courtWidth)}%`,
            top: `${Math.round((posy * 100) / courtHeight)}%`,
          };
          stateUpdatesMobile = {
            top: `${Math.round((posx * 100) / courtWidth)}%`,
            left: `${90 - Math.round(posy * 100) / courtHeight}%`,
          };
        } else if (courtWidth <= 867) {
          stateUpdates = {
            left: `${Math.round((posy * 100) / courtHeight)}%`,
            top: `${90 - Math.round((posx * 100) / courtWidth)}%`,
          };
          stateUpdatesMobile = {
            top: `${Math.round((posy * 100) / courtHeight)}%`,
            left: `${Math.round((posx * 100) / courtWidth)}%`,
          };
        }
        //save animations positions in state

        switch (i) {
          case 0:
            if (self.state.isEditModeOn === true) {
              let movs = self.state.movimientosB0;
              let movsM = self.state.movimientosB0Mobile;
              movs[position] = stateUpdates;
              movsM[position] = stateUpdatesMobile;
              let newPos = self.state.rivalPlayers;
              newPos[i][position] =
                courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
              self.setState({
                movimientosB0: movs,
                movimientosB0Mobile: movsM,
                rivalPlayers: newPos,
              });
            } else {
              let p = self.state.rivalPlayers;
              let movs = [...self.state.movimientosB0];
              let movsM = [...self.state.movimientosB0Mobile];
              if (clickProp !== "isClick") {
                p[0][self.state.positions] =
                  courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
                movsM[self.state.positions] = stateUpdatesMobile;
                movs[self.state.positions] = stateUpdates;
              }
              self.setState({
                movimientosB0: movs,
                movimientosB0Mobile: movsM,
                rivalPlayers: p,
              });
            }
            break;
          case 1:
            if (self.state.isEditModeOn === true) {
              let movs = self.state.movimientosB1;
              let movsM = self.state.movimientosB1Mobile;
              movs[position] = stateUpdates;
              movsM[position] = stateUpdatesMobile;
              let newPos = self.state.rivalPlayers;
              newPos[i][position] =
                courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
              self.setState({
                movimientosB1: movs,
                movimientosB1Mobile: movsM,
                rivalPlayers: newPos,
              });
            } else {
              let p = self.state.rivalPlayers;
              let movs = [...self.state.movimientosB1];
              let movsM = [...self.state.movimientosB1Mobile];
              if (clickProp !== "isClick") {
                p[1][self.state.positions] =
                  courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
                movsM[self.state.positions] = stateUpdatesMobile;
                movs[self.state.positions] = stateUpdates;
              }
              self.setState({
                movimientosB1: movs,
                movimientosB1Mobile: movsM,
                rivalPlayers: p,
              });
            }
            break;
          case 2:
            if (self.state.isEditModeOn === true) {
              let movs = self.state.movimientosB2;
              let movsM = self.state.movimientosB2Mobile;
              movs[position] = stateUpdates;
              movsM[position] = stateUpdatesMobile;
              let newPos = self.state.rivalPlayers;
              newPos[i][position] =
                courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
              self.setState({
                movimientosB2: movs,
                movimientosB2Mobile: movsM,
                rivalPlayers: newPos,
              });
            } else {
              let p = self.state.rivalPlayers;
              let movs = [...self.state.movimientosB2];
              let movsM = [...self.state.movimientosB2Mobile];
              if (clickProp !== "isClick") {
                p[2][self.state.positions] =
                  courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
                movsM[self.state.positions] = stateUpdatesMobile;
                movs[self.state.positions] = stateUpdates;
              }
              self.setState({
                movimientosB2: movs,
                movimientosB2Mobile: movsM,
                rivalPlayers: p,
              });
            }
            break;
          case 3:
            if (self.state.isEditModeOn === true) {
              let movs = self.state.movimientosB3;
              let movsM = self.state.movimientosB3Mobile;
              movs[position] = stateUpdates;
              movsM[position] = stateUpdatesMobile;
              let newPos = self.state.rivalPlayers;
              newPos[i][position] =
                courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
              self.setState({
                movimientosB3: movs,
                movimientosB3Mobile: movsM,
                rivalPlayers: newPos,
              });
            } else {
              let p = self.state.rivalPlayers;
              let movs = [...self.state.movimientosB3];
              let movsM = [...self.state.movimientosB3Mobile];
              if (clickProp !== "isClick") {
                p[3][self.state.positions] =
                  courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
                movsM[self.state.positions] = stateUpdatesMobile;
                movs[self.state.positions] = stateUpdates;
              }
              self.setState({
                movimientosB3: movs,
                movimientosB3Mobile: movsM,
                rivalPlayers: p,
              });
            }
            break;
          case 4:
            if (self.state.isEditModeOn === true) {
              let movs = self.state.movimientosB4;
              let movsM = self.state.movimientosB4Mobile;
              movs[position] = stateUpdates;
              movsM[position] = stateUpdatesMobile;
              let newPos = self.state.rivalPlayers;
              newPos[i][position] =
                courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
              self.setState({
                movimientosB4: movs,
                movimientosB4Mobile: movsM,
                rivalPlayers: newPos,
              });
            } else {
              let p = self.state.rivalPlayers;
              let movs = [...self.state.movimientosB4];
              let movsM = [...self.state.movimientosB4Mobile];
              if (clickProp !== "isClick") {
                p[4][self.state.positions] =
                  courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
                movsM[self.state.positions] = stateUpdatesMobile;
                movs[self.state.positions] = stateUpdates;
              }
              self.setState({
                movimientosB4: movs,
                movimientosB4Mobile: movsM,
                rivalPlayers: p,
              });
            }
            break;
          default:
            break;
        }
      }
    });

    this.state.Ball?.forEach((ballmovement, i) => {
      var ball = document.getElementById("Ball");
      var style = window.getComputedStyle(ball);
      const matrix =
        style.transform || style.webkitTransform || style.mozTransform;
      if (matrix === "none") {
        return {
          x: 0,
          y: 0,
          z: 0,
        };
      }

      // Can either be 2d or 3d transform
      const matrixType = matrix.includes("3d") ? "3d" : "2d";
      const matrixValues = matrix.match(/matrix.*\((.+)\)/)[1].split(", ");

      // 2d matrices have 6 values
      // Last 2 values are X and Y.
      // 2d matrices does not have Z value.
      if (matrixType === "2d") {
        //--------GUARDAR X E Y EN STATE-----------

        let posx = Math.round(matrixValues[4]);
        let posy = Math.round(matrixValues[5]);
        //save animation positions in % related to court width and height
        let courtWidth = document.getElementById("court").offsetWidth;
        let courtHeight = document.getElementById("court").offsetHeight;
        if (courtWidth >= 867) {
          stateUpdates = {
            left: `${Math.round((posx * 100) / courtWidth)}%`,
            top: `${Math.round((posy * 100) / courtHeight)}%`,
          };
          stateUpdatesMobile = {
            top: `${Math.round((posx * 100) / courtWidth)}%`,
            left: `${90 - Math.round(posy * 100) / courtHeight}%`,
          };
        } else if (courtWidth <= 867) {
          stateUpdates = {
            left: `${Math.round((posy * 100) / courtHeight)}%`,
            top: `${90 - Math.round((posx * 100) / courtWidth)}%`,
          };
          stateUpdatesMobile = {
            top: `${Math.round((posy * 100) / courtHeight)}%`,
            left: `${Math.round((posx * 100) / courtWidth)}%`,
          };
        }

        // const position = Number(
        //   this.state.posToDelete.replace("position-", "")
        // );
        //save animation positions in state
        switch (i) {
          case 0:
            if (self.state.isEditModeOn === true) {
              let movs = self.state.movimientosBall;
              let movsM = self.state.movimientosBallMobile;
              movs[position] = stateUpdates;
              movsM[position] = stateUpdatesMobile;
              let newPos = self.state.Ball;
              newPos[0][position] =
                courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
              self.setState({
                movimientosBall: movs,
                movimientosBallMobile: movsM,
                Ball: newPos,
              });
            } else {
              let p = self.state.Ball;
              let movs = [...self.state.movimientosBall];
              let movsM = [...self.state.movimientosBallMobile];
              if (clickProp !== "isClick") {
                p[0][self.state.positions] =
                  courtWidth >= 867 ? stateUpdates : stateUpdatesMobile;
                movsM[self.state.positions] = stateUpdatesMobile;
                movs[self.state.positions] = stateUpdates;
              }
              self.setState({
                movimientosBall: movs,
                movimientosBallMobile: movsM,
                Ball: p,
              });
            }
            break;
          default:
            break;
        }
      }
    });
    if (!this.state.isEditModeOn) {
      this.setState({ posToDelete: `position-${this.state.positions}` });
    }
    if (isClick === "isClick") {
      this.setState({ positions: Number(self.state.positions) + 1 });
      this.renderPositions();
      let positions = document.getElementsByClassName("positionNumber");
      for (var i = 0; i < positions.length; i++) {
        positions[i].classList.remove("active");
      }
    }
  };
  //END OF STORE POSITIONS ON CLICK
  setEditPosition = (id) => {
    const allPos = document.getElementsByClassName("positionNumber");
    for (var i = 0; i < allPos.length; i++) {
      allPos[i].classList.remove("active");
    }
    const element = document.getElementById(`${id}`);
    element.classList.add("active");
  };

  renderPositions = (isEdit, positions) => {
    const self = this;
    if (isEdit) {
      for (var i = 0; i < positions; i++) {
        var board = document.createElement("div");
        board.setAttribute("id", `position-${i}`);
        board.classList.add("positionNumber");
        board.classList.add("inactive");
        board.onclick = (e) => {
          this.setState({ posToDelete: e.currentTarget.id });
          this.setEditPosition(e.currentTarget.id);
        };
        board.innerHTML = `
          <p>${i + 1}</p>
          <div id="${i}" class="deletePosButton">
          <img src="/assets/AnimPos-icon.svg"/>
          </div>
         `;
        document.getElementById("positions-container").append(board);
      }
    } else {
      var board = document.createElement("div");
      board.setAttribute("id", `position-${self.state.positions}`);
      board.classList.add("positionNumber");
      board.onclick = (e) => {
        this.setState({ posToDelete: e.currentTarget.id });
        this.setEditPosition(e.currentTarget.id);
      };
      board.innerHTML = `
      <p>${Number(self.state.positions) + 1}</p>
          <div id="${i}" class="deletePosButton">
          <img src="/assets/AnimPos-icon.svg"/>
          </div>
         `;
      document.getElementById("positions-container").appendChild(board);
    }
    let pos = document.getElementsByClassName("deletePosButton");
    if (pos.length > 0) {
      for (let i = 0; i < pos.length; i++) {
        const elemento = pos[i];
        // eslint-disable-next-line no-loop-func
        elemento.addEventListener("click", function () {
          self.setState({ deleteExercisePopup: true });
        });
      }
    }
  };
  regularpositions = (button) => {
    let positions = document.getElementsByClassName("positionNumber");
    if (button === "update") {
      for (var i = 0; i < positions.length; i++) {
        positions[i].classList.remove("inactive");
        positions[i].classList.remove("active");
      }
    } else if (button === "edit") {
      for (var i = 0; i < positions.length; i++) {
        positions[i].classList.add("inactive");
      }
      positions[0].classList.add("active");
    }
  };
  // handle remove position of animation
  handlePositions = async () => {
    const position = Number(this.state.posToDelete.replace("position-", ""));
    const element = document.getElementById(`position-${position}`);
    await element.remove();
    if (position === 0) {
      await this.setState({ ownPlayers: [], rivalPlayers: [], Ball: [] });
    }

    let mov0 = [this.state.movimientos0];
    mov0.splice(position, 1);
    let mov0M = this.state.movimientos0Mobile;
    mov0M.splice(position, 1);
    let mov1 = this.state.movimientos1;
    mov1.splice(position, 1);
    let mov1M = this.state.movimientos1Mobile;
    mov1M.splice(position, 1);
    let mov2 = this.state.movimientos2;
    mov2.splice(position, 1);
    let mov2M = this.state.movimientos2Mobile;
    mov2M.splice(position, 1);
    let mov3 = this.state.movimientos3;
    mov3.splice(position, 1);
    let mov3M = this.state.movimientos3Mobile;
    mov3M.splice(position, 1);
    let mov4 = this.state.movimientos4;
    mov4.splice(position, 1);
    let mov4M = this.state.movimientos4Mobile;
    mov4M.splice(position, 1);
    let movB0 = this.state.movimientosB0;
    movB0.splice(position, 1);
    let movB0M = this.state.movimientosB0Mobile;
    movB0M.splice(position, 1);
    let movB1 = this.state.movimientosB1;
    movB1.splice(position, 1);
    let movB1M = this.state.movimientosB1Mobile;
    movB1M.splice(position, 1);
    let movB2 = this.state.movimientosB2;
    movB2.splice(position, 1);
    let movB2M = this.state.movimientosB2Mobile;
    movB2M.splice(position, 1);
    let movB3 = this.state.movimientosB3;
    movB3.splice(position, 1);
    let movB3M = this.state.movimientosB3Mobile;
    movB3M.splice(position, 1);
    let movB4 = this.state.movimientosB4;
    movB4.splice(position, 1);
    let movB4M = this.state.movimientosB4Mobile;
    movB4M.splice(position, 1);
    let movBall = this.state.movimientosBall;
    movBall.splice(position, 1);
    let movBallM = this.state.movimientosBallMobile;
    movBallM.splice(position, 1);

    await this.setState({
      posToDelete: `position-${position - 1}`,
      deleteExercisePopup: false,
      movimientos0: mov0,
      movimientos0Mobile: mov0M,
      movimientos1: mov1,
      movimientos1Mobile: mov1M,
      movimientos2: mov2,
      movimientos2Mobile: mov2M,
      movimientos3: mov3,
      movimientos3Mobile: mov3M,
      movimientos4: mov4,
      movimientos4Mobile: mov4M,
      movimientosB0: movB0,
      movimientos0Mobile: movB0M,
      movimientosB1: movB1,
      movimientos1Mobile: movB1M,
      movimientosB2: movB2,
      movimientos2Mobile: movB2M,
      movimientosB3: movB3,
      movimientosB3Mobile: movB3M,
      movimientosB4: movB4,
      movimientosB4Mobile: movB4M,
      movimientosBall: movBall,
      movimientosBallMobile: movBallM,
    });
    let positions = document.getElementsByClassName("positionNumber");
    for (var i = 0; i < positions.length; i++) {
      positions[i].id = `position-${i}`;
      var spanEl = positions[i].querySelector("p");
      spanEl.innerText = [i + 1];
    }
  };

  //end of handle remove position of animation
  //MULTIPLIE SPEED FUNCTION
  multiplySpeed = () => {
    var speedState = !this.state.animatiomultipliedspeed;
    this.setState({
      animatiomultipliedspeed: speedState,
    });
  };
  //END OF MULTIPLIE SPEED

  // CREATE SQUARE FIGURE
  // createRectangulo = () => {
  //   const r1Info = { x: 20, y: 30, w: 100, h: 50 };
  //   const r1Style = { borderColor: 'red', borderWidth: 10 };
  //  drawRect(r1Info, r1Style);
  // }
  // END OF CREATE SQUARE FIGURE
  handleCancelDeleteClick = () => {
    this.setState({ deleteExercisePopup: false });
  };
  returnStaringPositionNumber = (pos) => {
    if (typeof pos === "object") {
      let height = document.getElementById("court").offsetHeight;
      let width = document.getElementById("court").offsetWidth;
      let x = pos[0].left.replace("%", "");
      let xFinal = (x / 100) * width;
      let y = pos[0].top.replace("%", "");
      let yFinal = (y / 100) * height;
      let startingPos = { x: xFinal, y: yFinal };
      return startingPos;
    } else if (typeof pos === "function") {
      return { x: 0, y: 0 };
    }
  };
  changeActivePosition = (pos) => {
    if (pos === null) {
      return;
    } else {
      const position = Number(this.state.posToDelete.replace("position-", ""));
      if (typeof pos === "object") {
        let height = document.getElementById("court").offsetHeight;
        let width = document.getElementById("court").offsetWidth;
        let x = pos[position].left.replace("%", "");
        let xFinal = (x / 100) * width;
        let y = pos[position].top.replace("%", "");
        let yFinal = (y / 100) * height;
        let startingPos = { x: xFinal, y: yFinal };
        return startingPos;
      } else if (typeof pos === "function") {
        return { x: 0, y: 0 };
      }
    }
  };

  // DESKTOP RIGHT CLICK
  handleRightClick = (e, target, pos) => {
    e.preventDefault();
    const self = this;
    if (e.type === "contextmenu") {
      //show delete player pop up
      this.setState({
        isModalOpen: !this.state.isModalOpen,
        PopUpposx: e.clientX,
        PopUpposy: e.clientY,
        target: target,
        pos: pos,
      });
    } else if (e.type === "touchstart") {
      self.setState({
        isModalOpen: !self.state.isModalOpen,
        PopUpposx: e.touches[0].clientX - 105,
        PopUpposy: e.touches[0].clientY,
        target: target,
        pos: pos,
      });
    }
  };

  //END OF DESKTOP RIGHT CLICK
  deletePos = async () => {
    await this.handdleDeletePlayer();
  };
  handdleDeletePlayer = () => {
    if (this.state.target === "own") {
      let bkp = this.state.ownPlayers;
      switch (this.state.pos) {
        case 0:
          bkp.splice(0, 1);
          this.setState({
            ownPlayers: bkp,
          });
          if (this.state.ownPlayers.length === 0) {
            this.setState({
              movimientos0: [],
              movimientos0Mobile: [],
            });
          } else {
            this.setState({
              movimientos1: [],
              movimientos1Mobile: [],
            });
          }
          break;
        case 1:
          bkp.splice(1, 1);
          this.setState({
            ownPlayers: bkp,
          });
          if (this.state.ownPlayers.length === 1) {
            this.setState({
              movimientos1: [],
              movimientos1Mobile: [],
            });
          } else if (this.state.ownPlayers.length === 2) {
            this.setState({
              movimientos2: [],
              movimientos2Mobile: [],
            });
          }
          break;
        case 2:
          bkp.splice(2, 1);
          this.setState({
            ownPlayers: bkp,
          });
          if (this.state.ownPlayers.length === 2) {
            this.setState({
              movimientos2: [],
              movimientos2Mobile: [],
            });
          } else if (this.state.ownPlayers.length === 3) {
            this.setState({
              movimientos3: [],
              movimientos3Mobile: [],
            });
          }
          break;
        case 3:
          bkp.splice(3, 1);
          this.setState({
            ownPlayers: bkp,
          });
          if (this.state.ownPlayers.length === 3) {
            this.setState({
              movimientos3: [],
              movimientos3Mobile: [],
            });
          } else if (this.state.ownPlayers.length === 4) {
            this.setState({
              movimientos4: [],
              movimientos4Mobile: [],
            });
          }
          break;
        case 4:
          bkp.splice(4, 1);
          this.setState({
            ownPlayers: bkp,
          });
          if (this.state.ownPlayers.length === 4) {
            this.setState({
              movimientos4: [],
              movimientos4Mobile: [],
            });
          }
          break;
        default:
          break;
      }
    } else if (this.state.target === "rival") {
      let bkp = this.state.rivalPlayers;
      switch (this.state.pos) {
        case 0:
          bkp.splice(0, 1);
          this.setState({
            rivalPlayers: bkp,
          });
          if (this.state.rivalPlayers.length === 0) {
            this.setState({
              movimientosB0: [],
              movimientosB0Mobile: [],
            });
          } else {
            this.setState({
              movimientosB1: [],
              movimientosB1Mobile: [],
            });
          }
          break;
        case 1:
          bkp.splice(1, 1);
          this.setState({
            rivalPlayers: bkp,
          });
          if (this.state.rivalPlayers.length === 1) {
            this.setState({
              movimientos1: [],
              movimientos1Mobile: [],
            });
          } else if (this.state.rivalPlayers.length === 2) {
            this.setState({
              movimientosB2: [],
              movimientosB2Mobile: [],
            });
          }
          break;
        case 2:
          bkp.splice(2, 1);
          this.setState({
            rivalPlayers: bkp,
          });
          if (this.state.rivalPlayers.length === 2) {
            this.setState({
              movimientosB2: [],
              movimientosB2Mobile: [],
            });
          } else if (this.state.rivalPlayers.length === 3) {
            this.setState({
              movimientosB3: [],
              movimientosB3Mobile: [],
            });
          }
          break;
        case 3:
          bkp.splice(3, 1);
          this.setState({
            rivalPlayers: bkp,
          });
          if (this.state.rivalPlayers.length === 3) {
            this.setState({
              movimientos3: [],
              movimientos3Mobile: [],
            });
          } else if (this.state.rivalPlayers.length === 4) {
            this.setState({
              movimientosB4: [],
              movimientosB4Mobile: [],
            });
          }
          break;
        case 4:
          bkp.splice(4, 1);
          this.setState({
            rivalPlayers: bkp,
          });
          if (this.state.rivalPlayers.length === 4) {
            this.setState({
              movimientosB4: [],
              movimientosB4Mobile: [],
            });
          }
          break;
        default:
          break;
      }
    } else if (this.state.target === "ball") {
      this.setState({
        movimientosBall: [],
        movimientosBallMobile: [],
        Ball: [],
      });
    }
    this.setState({
      isModalOpen: !this.state.isModalOpen,
    });
  };

  handleTouchStart = (e, target, i) => {
    this.setState({ isPressing: true });
    this.timeoutRef.current = setTimeout(() => {
      // Handle the long press event here
      this.handleRightClick(e, target, i);
    }, 2000); // Change the duration as per your requirement
  };

  handleTouchEnd = () => {
    clearTimeout(this.timeoutRef.current);
  };
  render() {
    const {
      ownPlayers,
      rivalPlayers,
      shapes,
      Ball,
      animationRunning,
      isDragin,
      isModalOpen,
      PopUpposy,
      PopUpposx,
    } = this.state;
    return (
      <>
        <Navbar>
          <div className="back-arrow-m">
            <Link to="/app/main">
              <img src="/assets/BackArrow.png" alt="nada" />
            </Link>
            <h1>Tacticas</h1>
          </div>
          <div className={`buttons  ${this.props.isEdit ? "is-edit" : ""}`}>
            <>
              {this.state.isEditModeOn ? (
                <SectorNav
                  onClick={(e) => {
                    if (this.props.isEdit) {
                      this.setState({ isEditModeOn: false });
                      this.regularpositions("update");
                    }
                  }}
                >
                  <img
                    src="/assets/update-icon.png"
                    alt="update icon"
                    className="edit-icon"
                  />
                  <p>Actualizar</p>
                </SectorNav>
              ) : (
                <SectorNav
                  onClick={(e) => {
                    if (this.props.isEdit) {
                      this.setState({ isEditModeOn: true });
                      this.regularpositions("edit");
                    }
                  }}
                >
                  <img
                    className="edit-icon"
                    src="/assets/edit-icon.svg"
                    alt="edit icon"
                  />
                  <p>Editar</p>
                </SectorNav>
              )}
            </>
          </div>
          <SectorNav onClick={this.handleSaveClick} className="saveButton">
            <img src="/assets/Save-icon.png" alt="save icon" />
            <p>Guardar</p>
          </SectorNav>
          <div className="own-player-m" onClick={this.renderPlayer.bind(this)}>
            <img src="/assets/Player-icon.png" alt="player-con" />
          </div>
          <div
            className="rival-player-m"
            onClick={this.renderRivalPlayer.bind(this)}
          >
            <img src="/assets/Player-icon.png" alt="rival-icon" />
          </div>
          <div className="ball-m" onClick={this.renderBall.bind(this)}>
            <img src="/assets/Ball-icon.png" alt="ball-icon" />
          </div>
        </Navbar>
        <Container id="court-container">
          <Sidebar>
            <div onClick={this.renderPlayer.bind(this)}>
              <img src="/assets/Player-icon.png" alt="player-con" />
            </div>
            <div onClick={this.renderRivalPlayer.bind(this)}>
              <img src="/assets/Player-icon.png" alt="rival-icon" />
            </div>
            <div onClick={this.renderBall.bind(this)}>
              <img src="/assets/Ball-icon.png" alt="ball-icon" />
            </div>
          </Sidebar>
          <SuccessPopUp />
          <Court id="court">
            <img
              src="/assets/court-vertical.png"
              alt="square-icon"
              className="court-img-m"
            />
            <img
              src="/assets/court-lines.png"
              alt="square-icon"
              className="court-img"
            />
            {ownPlayers.length !== 0 &&
              ownPlayers.map((Widget, i) => (
                <Draggable
                  id="0"
                  handle=".handle"
                  position={
                    isDragin === true ? null : this.changeActivePosition(Widget)
                  }
                  onDrag={(e) => {
                    this.setState({ isDragin: true });
                    this.handleTouchEnd();
                  }}
                  onStop={(e) => {
                    if (isDragin) this.handlePositionClick();
                    this.setState({ isDragin: false });
                    this.handleTouchEnd();
                  }}
                  onTouchEnd={this.handleTouchEnd}
                  grid={[1, 1]}
                  scale={1}
                >
                  <RedDot
                    className="handle"
                    id={i}
                    onContextMenu={(e) => this.handleRightClick(e, "own", i)}
                    onTouchStart={(e) => {
                      if (!isDragin) this.handleTouchStart(e, "own", i);
                    }}
                    onDrag={(e) => this.handleTouchEnd()}
                    onTouchCancel={(e) => {
                      this.handleTouchEnd();
                    }}
                  >
                    <p>{i + 1}</p>
                  </RedDot>
                </Draggable>
              ))}
            {rivalPlayers.length !== 0 &&
              rivalPlayers.map((Widget, i) => (
                <Draggable
                  id="0"
                  handle=".handle"
                  position={
                    isDragin === true ? null : this.changeActivePosition(Widget)
                  }
                  onDrag={(e) => {
                    this.setState({ isDragin: true });
                    this.handleTouchEnd();
                  }}
                  onStop={(e) => {
                    if (isDragin) this.handlePositionClick();
                    this.setState({ isDragin: false });
                    this.handleTouchEnd();
                  }}
                  onTouchEnd={this.handleTouchEnd}
                  grid={[1, 1]}
                  scale={1}
                >
                  <BlueDot
                    className="handle"
                    id={`b-${i}`}
                    onContextMenu={(e) => this.handleRightClick(e, "rival", i)}
                    onTouchStart={(e) => {
                      if (!isDragin) this.handleTouchStart(e, "rival", i);
                    }}
                    onDrag={(e) => this.handleTouchEnd()}
                    onTouchCancel={(e) => {
                      this.handleTouchEnd();
                    }}
                  >
                    <p>{i + 1}</p>
                  </BlueDot>
                </Draggable>
              ))}
            {shapes.length !== 0 &&
              shapes.map((SquareShape, i) => (
                <Draggable
                  handle=".handle"
                  position={
                    isDragin === true
                      ? null
                      : this.changeActivePosition(SquareShape)
                  }
                  defaultPosition={this.returnStaringPositionNumber(
                    SquareShape
                  )}
                  onStart={(e) => this.setState({ isDragin: true })}
                >
                  <Square id={i} className="handle">
                    <div className="tr-transform__scale-point--br"></div>
                  </Square>
                </Draggable>
              ))}
            {Ball.length !== 0 &&
              Ball.map((BallShape, i) => (
                <Draggable
                  id="Ball"
                  handle=".handle"
                  position={
                    isDragin === true
                      ? null
                      : this.changeActivePosition(BallShape)
                  }
                  onDrag={(e) => {
                    this.setState({ isDragin: true });
                    this.handleTouchEnd();
                  }}
                  onStop={(e) => {
                    if (isDragin) this.handlePositionClick();
                    this.setState({ isDragin: false });
                    this.handleTouchEnd();
                  }}
                  onTouchEnd={this.handleTouchEnd}
                  grid={[1, 1]}
                  scale={1}
                >
                  <BallDot
                    className="handle"
                    id="Ball"
                    onContextMenu={(e) => this.handleRightClick(e, "ball", i)}
                    onTouchStart={(e) => {
                      if (!isDragin) this.handleTouchStart(e, "ball", i);
                    }}
                    onDrag={(e) => this.handleTouchEnd()}
                    onTouchCancel={(e) => {
                      this.handleTouchEnd();
                    }}
                  ></BallDot>
                </Draggable>
              ))}
          </Court>
          <VideoSlider
            updateWindowDimensions={this.updateWindowDimensions.bind(this)}
          />
          <div className="extra-div"></div>
          <AnimatorBar>
            <p>Controles</p>
            {!animationRunning ? (
              <>
                <AnimatorBarContainer onClick={this.play}>
                  <img src="/assets/Play-icon.svg" alt="nada" />
                </AnimatorBarContainer>
              </>
            ) : (
              <>
                <AnimatorBarContainer id="pauseButton" onClick={this.pause}>
                  <img src="/assets/pause-icon.png" alt="nada" />
                </AnimatorBarContainer>
              </>
            )}
            <AnimatorBarContainer
              className="loopButton"
              id="stop"
              onClick={this.reloadPostions}
            >
              <img src="/assets/square-icon.png" alt="nada" />
            </AnimatorBarContainer>
            <AnimatorBarContainer
              id="X2"
              onClick={this.multiplySpeed}
              // eslint-disable-next-line react/jsx-no-duplicate-props
              className={`multpieButton ${
                this.state.animatiomultipliedspeed
                  ? "loop-active"
                  : "loop-unactive"
              }`}
            >
              <p>2X</p>
            </AnimatorBarContainer>
            <AnimatorBarContainer
              className={`lastContainers ${
                this.state.animationLoopState ? "loop-active" : "loop-unactive"
              }`}
              onClick={this.handleLoop}
            >
              <img src="/assets/loop-icon.png" alt="nada" />
            </AnimatorBarContainer>
            <AnimatorBarContainer id="positions-container"></AnimatorBarContainer>
            <div
              className={`lastContainers disclaimer ${
                this.state.isEditModeOn ? "unactive" : "active"
              }`}
            >
              <p>
                Guardar posición <span className="desktop-only"> --&#62; </span>
              </p>
            </div>
            <div
              className={`lastContainers ${
                this.state.isEditModeOn ? "unactive" : "active"
              }`}
              onClick={(e) => {
                if (!this.state.isEditModeOn) {
                  this.handlePositionClick("isClick");
                }
              }}
            >
              <img src="/assets/AddPos-icon.svg" alt="nada" />
            </div>
          </AnimatorBar>
          {this.state.deleteExercisePopup ? (
            <div className="delete-position-popup">
              <h2>Estás seguro que deseas eliminar esta posición?</h2>
              <div>
                <button className="btn-primary" onClick={this.handlePositions}>
                  Si
                </button>
                <button
                  className="btn-primary ghost"
                  onClick={this.handleCancelDeleteClick}
                >
                  No
                </button>
              </div>
            </div>
          ) : null}
        </Container>
        {isModalOpen ? (
          <Modal
            isOpen={isModalOpen}
            toggleModal={(e) => this.setState({ isModalOpen: !isModalOpen })}
            closeOnOutsideClick={true}
            posx={PopUpposx}
            posy={PopUpposy}
            deletePos={this.deletePos}
          />
        ) : null}
      </>
    );
  }
}

export default EdicionContainer;
